var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSuppSilage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 39.147H45",
    stroke: "#D3B58A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6767 39.0652H22.6028V14.7375L28.8956 10.0487C28.9764 9.98812 29.0421 9.90968 29.0876 9.81952C29.1331 9.72936 29.1571 9.62991 29.1578 9.52893C29.1578 9.18035 28.9265 8.8981 28.581 8.8981C28.3851 8.8981 28.1183 9.06005 28.0473 9.12946L21.355 14.1128V39.0652H18.9844V13.59L29.3306 6L39.6767 13.5884V39.0652Z",
    fill: "#D3B58A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6973 39.0652H7.75018V22.0452L6.8772 21.6087V39.0652H5.2207V21.2432L12.459 15.9328L19.6973 21.2416V39.0652Z",
    fill: "#D3B58A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSuppSilage);
export default __webpack_public_path__ + "static/media/ic-supp-silage.02943d584379005b40016674d5ae1d56.svg";
export { ForwardRef as ReactComponent };